module.exports = __webpack_public_path__ + "static/media/docx-icon.927a0df9.svg";